import React, { useState, useEffect, useRef } from 'react';
import InvestmentCard from './InvestmentCard';
import logoSrc from '../img/logo.png';
import ContactForm from '../ContactForm';

import './Investments.css';

const InvestmentsPage = () => {
  const contactFormRef = useRef();
  const [investments, setInvestments] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState('All');

  const handleOpenContactForm = () => {
    if (contactFormRef.current) {
      contactFormRef.current.openForm();
    }
  };

  useEffect(() => {
    fetch('https://apiqms.shigjeta.com/api/investments')
      .then((response) => response.json())
      .then((data) => {
        // Filter out any investments that do not have a valid 'id'.
        const validInvestments = data.filter(inv => inv.id);
        
        if (validInvestments.length !== data.length) {
          console.warn("Warning: Some investment records were ignored because they were missing an 'id' property.");
        }

        setInvestments(validInvestments);
      })
      .catch((error) => {
        console.error('Error loading investment data:', error);
      });
  }, []);

  const filteredInvestments = selectedCategory === 'All'
    ? investments
    : investments.filter(investment => investment.category === selectedCategory);

  const handleCategoryClick = (category) => {
    setSelectedCategory(category);
  };
  
  return (
    <>
      {/* ... (Hero section and other JSX remains the same) ... */}
      <div className="banner-logo" id="sectionBanner1">
        {logoSrc && <img src={logoSrc} alt="Shigjeta Logo" />}
      </div>
      <section className="banner-section" id="sectionBanner">
        <div className="banner-container">
          <div className="banner-text">
            <h1 className="banner-title">fortune foundry, crafting success.</h1>
            <p className="banner-description">
            Sculpt your financial future with exclusive, strategic investments and unlock long-term growth.
            </p>
            <a onClick={handleOpenContactForm} className="banner-button">
              Start Now
            </a>
          </div>
          <div className="shop-hero-background"></div>
        </div>
      </section>
      <div className='img-background'>
      <img
              className="img"
              id='banner1-video'
              src="/img/Invest in MVPThumbnail.png"
              autoPlay
              muted
              loop
              playsInline
              onError={(e) => console.error('Error loading video:', e)}
            />
      </div>
      
      <section className="shop-products" id="investments">
        {/* ... (Category filter JSX remains the same) ... */}
        <div className="shop-header">
          <h1>Our Investment Opportunities</h1>
          <p>Discover unique investment opportunities tailored to your goals.</p>
        </div>
        <div className="shop-category-filter">
          <h3>Select Your Investment Category</h3>
          <p className="category-intro-text">
            Choose your preferred category to explore available opportunities.
          </p>
          <ul className="category-list">
          {['All', 'Mikro Ticket Size', 'Small Ticket Size', 'Medium Ticket Size', 'Large Ticket Size'].map((category) => (
              <li key={category}>
                <a
                  href="#!"
                  className={`category-item ${selectedCategory === category ? 'active' : ''}`}
                  onClick={() => handleCategoryClick(category)}
                >
                  {category}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div className="shop-product-list">
          {filteredInvestments.length > 0 ? (
            filteredInvestments.map((investment) => (
              <InvestmentCard
                key={investment.id}
                product={investment}
              />
            ))
          ) : (
            <p>No investments found in this category.</p>
          )}
        </div>
      </section>

      {/* ... (CTA and ContactForm JSX remains the same) ... */}
      <section className="shop-cta">
        <div className="shop-cta-container">
          <p className="shop-cta-text">
            Found an investment opportunity? Contact us through our Connect Us system for more information or special requests.
          </p>
        </div>
      </section>
      <ContactForm ref={contactFormRef} />
    </>
  );
};

export default InvestmentsPage;